import { Typography } from '@mui/material';
import ButtonWithSpinner from '../../../../../../../../../components/buttons/ButtonWithSpinner';
import './EntryContainer.scss';

export default function EntryContainer({
  label,
  onApply,
  children,
  disabled,
  ...rest
} = {
  onApply: () => null,
  children: null,
  disabled: true,
  label: '',
}) {
  return (
    <div {...rest} className='apply-text-entry-container'>
      <div className='row'>
        <Typography variant='subtitle1' className='label'>
          {label}
        </Typography>
        {children}
      </div>

      <ButtonWithSpinner
        label='Apply'
        disabled={disabled}
        onClick={onApply}
      />
    </div>
  );
}
